import { gql } from '__generated__';

export default gql(`
  query GetInvitations($project_id: ID!, $event_id: ID!, $search: String) {
    project(id: $project_id) {
      id
      event(id: $event_id) {
        id
        active
        invitations(search: $search) {
          id
          prefix
          has_unique_codes
          uses
          max_uses
          active
          available
          deletable
          start_date
          end_date
          tickets {
            id
            title
          }
        }
      }
    }
  }
`);
